export default __webpack_public_path__ + "static/media/ill-success.bf1d8d2d.svg";